/* eslint-disable max-len */
// publicPolicy------------------------------
export const PublicPolicyKey = {
  PP_QUESTION_1: 'ppQuestion1',
  PP_QUESTION_2: 'ppQuestion2',
  PP_QUESTION_3: 'ppQuestion3',
  PP_QUESTION_4: 'ppQuestion4'
};

export const PublicPolicyLabel = {
  PP_PUBLIC_POLICY_1: 'Political contributions',
  PP_QUESTION_1: '',
  PP_QUESTION_2: '',
  PP_QUESTION_3: '',
  PP_QUESTION_4: ''
};

// marketingAndLabeling------------------------------
export const MarketingAndLabelingKey = {
  MAL_QUESTION_1: 'malQuestion1',
  MAL_QUESTION_2: 'malQuestion2',
  MAL_QUESTION_3: 'malQuestion3',
  MAL_QUESTION_4: 'malQuestion4',
  MAL_QUESTION_5: 'malQuestion5',
  MAL_QUESTION_6: 'malQuestion6',
  MAL_QUESTION_7: 'malQuestion7',
  MAL_QUESTION_8: 'malQuestion8',
  MAL_QUESTION_9: 'malQuestion9',
  MAL_QUESTION_10: 'malQuestion10',

  MAL_QUESTION_11: 'malQuestion11',
  MAL_QUESTION_12: 'malQuestion12',
  MAL_QUESTION_13: 'malQuestion13',
  MAL_QUESTION_14: 'malQuestion14',
  MAL_QUESTION_15: 'malQuestion15',
  MAL_QUESTION_16: 'malQuestion16',
  MAL_QUESTION_17: 'malQuestion17',
  MAL_QUESTION_18: 'malQuestion18',
  MAL_QUESTION_19: 'malQuestion19',
  MAL_QUESTION_20: 'malQuestion20',

  MAL_QUESTION_21: 'malQuestion21',
  MAL_QUESTION_22: 'malQuestion22',
  MAL_QUESTION_23: 'malQuestion23',
  MAL_QUESTION_24: 'malQuestion24',
  MAL_QUESTION_25: 'malQuestion25',
  MAL_QUESTION_26: 'malQuestion26',
  MAL_QUESTION_27: 'malQuestion27',
  MAL_QUESTION_28: 'malQuestion28',
  MAL_QUESTION_29: 'malQuestion29',
  MAL_QUESTION_30: 'malQuestion30'
};

export const MarketingAndLabelingLabel = {
  MAL_MARKETING_AND_LABELING_1:
    'Requirements for product and service information and labeling',
  MAL_MARKETING_AND_LABELING_2:
    'Incidents of non-compliance concerning product and service information and labeling',
  MAL_MARKETING_AND_LABELING_3:
    'Incidents of non-compliance concerning marketing communications',
  MAL_MARKETING_AND_LABELING_4:
    'Substantiated complaints concerning breaches of customer privacy and losses of customer data',

  MAL_HEADING_1: 'i. The sourcing of components of the product or service.',
  MAL_HEADING_2:
    'ii. Content, particularly with regard to substances that might produce an environmental or social impact.',
  MAL_HEADING_3: 'iii. Safe use of the product or service.',
  MAL_HEADING_4:
    'iv. Disposal of the product and environmental or social impacts.',
  MAL_HEADING_5: 'v. Other (explain).',
  MAL_HEADING_6:
    'i. Incidents of non-compliance with regulations resulting in a fine or penalty.',
  MAL_HEADING_7:
    'ii. Incidents of non-compliance with regulations resulting in a warning.',
  MAL_HEADING_8: 'iii. Incidents of non-compliance with voluntary codes.',
  MAL_HEADING_9:
    'i. Incidents of non-compliance with regulations resulting in a fine or penalty.',
  MAL_HEADING_10:
    'ii. Incidents of non-compliance with regulations resulting in a warning.',
  MAL_HEADING_11: 'iii. Incidents of non-compliance with voluntary codes.',
  MAL_HEADING_12:
    'i. Complaints received from outside parties and substantiated by the organization.',
  MAL_HEADING_13: 'ii. Complaints from regulatory bodies.',

  MAL_QUESTION_1: '',
  MAL_QUESTION_2: '',
  MAL_QUESTION_3: '',
  MAL_QUESTION_4: '',
  MAL_QUESTION_5: '',
  MAL_QUESTION_6:
    'significant product or service categories covered by and assessed for compliance',
  MAL_QUESTION_7: 'Total product or service categories',
  MAL_QUESTION_8: '',
  MAL_QUESTION_9: '',
  MAL_QUESTION_10: '',

  MAL_QUESTION_11: '',
  MAL_QUESTION_12: '',
  MAL_QUESTION_13: '',
  MAL_QUESTION_14: '',
  MAL_QUESTION_15: '',
  MAL_QUESTION_16: '',
  MAL_QUESTION_17: '',
  MAL_QUESTION_18: '',
  MAL_QUESTION_19: '',
  MAL_QUESTION_20: '',

  MAL_QUESTION_21: '',
  MAL_QUESTION_22: '',
  MAL_QUESTION_23: '',
  MAL_QUESTION_24: '',
  MAL_QUESTION_25: '',
  MAL_QUESTION_26: '',
  MAL_QUESTION_27: '',
  MAL_QUESTION_28: '',
  MAL_QUESTION_29: '',
  MAL_QUESTION_30: ''
};

// economicPerformance----------------------------------
export const EconomicPerformanceKey = {
  EP_QUESTION_1: 'epQuestion1',
  EP_QUESTION_2: 'epQuestion2',
  EP_QUESTION_3: 'epQuestion3',
  EP_QUESTION_4: 'epQuestion4',
  EP_QUESTION_5: 'epQuestion5',
  EP_QUESTION_6: 'epQuestion6',
  EP_QUESTION_7: 'epQuestion7',
  EP_QUESTION_8: 'epQuestion8',
  EP_QUESTION_9: 'epQuestion9',
  EP_QUESTION_10: 'epQuestion10',

  EP_QUESTION_11: 'epQuestion11',
  EP_QUESTION_12: 'epQuestion12',
  EP_QUESTION_13: 'epQuestion13',
  EP_QUESTION_14: 'epQuestion14',
  EP_QUESTION_15: 'epQuestion15',
  EP_QUESTION_16: 'epQuestion16',
  EP_QUESTION_17: 'epQuestion17',
  EP_QUESTION_18: 'epQuestion18',
  EP_QUESTION_19: 'epQuestion19',
  EP_QUESTION_20: 'epQuestion20',

  EP_QUESTION_21: 'epQuestion21',
  EP_QUESTION_22: 'epQuestion22',
  EP_QUESTION_23: 'epQuestion23',
  EP_QUESTION_24: 'epQuestion24',
  EP_QUESTION_25: 'epQuestion25',
  EP_QUESTION_26: 'epQuestion26',
  EP_QUESTION_27: 'epQuestion27',
  EP_QUESTION_28: 'epQuestion28',
  EP_QUESTION_29: 'epQuestion29',
  EP_QUESTION_30: 'epQuestion30',

  EP_QUESTION_31: 'epQuestion31',
  EP_QUESTION_32: 'epQuestion32',
  EP_QUESTION_33: 'epQuestion33',
  EP_QUESTION_34: 'epQuestion34',
  EP_QUESTION_35: 'epQuestion35',
  EP_QUESTION_36: 'epQuestion36',
  EP_QUESTION_37: 'epQuestion37',
  EP_QUESTION_38: 'epQuestion38',
  EP_QUESTION_39: 'epQuestion39',
  EP_QUESTION_40: 'epQuestion40'
};

export const EconomicPerformanceLabel = {
  EP_ECONOMIC_PERFORMANCE_1: 'Direct economic value generated and distributed',
  EP_ECONOMIC_PERFORMANCE_2:
    'Financial implications and other risks and opportunities due to climate change',
  EP_ECONOMIC_PERFORMANCE_3:
    'Defined benefit plan obligations and other retirement plans',
  EP_ECONOMIC_PERFORMANCE_4: 'Financial assistance received from government',

  EP_HEADING_1: 'i. Direct economic value generated: revenues',
  EP_HEADING_2:
    'ii. Economic value distributed: operating costs, employee wages and benefits, payments to providers of capital, payments to government by country, and community investments.',
  EP_HEADING_3:
    'iii. Economic value retained: ‘direct economic value generated’ less ‘economic value distributed’.',
  EP_HEADING_4:
    'i. A description of the risk or opportunity and its classification as either physical, regulatory, or other.',
  EP_HEADING_5:
    'ii. A description of the impact associated with the risk or opportunity.',
  EP_HEADING_6:
    'iii. The financial implications of the risk or opportunity before action is taken.',
  EP_HEADING_7: 'iv. The methods used to manage the risk or opportunity.',
  EP_HEADING_8:
    'v. The costs of actions taken to manage the risk or opportunity.',
  EP_HEADING_9:
    'i. The extent to which the scheme’s liabilities are estimated to be covered by the assets that have been set aside to meet them.',
  EP_HEADING_10: 'ii. The basis on which that estimate has been arrived at.',
  EP_HEADING_11: 'iii. When that estimate was made.',

  EP_HEADING_12: 'i. Tax relief and tax credits.',
  EP_HEADING_13: 'ii. Subsidies.',
  EP_HEADING_14:
    'iii. Investment grants, research and development grants, and other relevant types of grant.',
  EP_HEADING_15: 'iv. Awards.',
  EP_HEADING_16: 'v. Royalty holidays.',
  EP_HEADING_17: 'vi. Financial assistance from Export Credit Agencies (ECAs).',
  EP_HEADING_18: 'vii. Financial incentives.',
  EP_HEADING_19:
    'viii. Other financial benefits received or receivable from any government for any operation.',

  EP_HEADING_20: 'Tax relief and tax credits',
  EP_HEADING_21: 'Subsidies',
  EP_HEADING_22:
    'Investment grants, research and development grants, and other relevant types of grant',
  EP_HEADING_23: 'Awards',
  EP_HEADING_24: 'Royalty holidays',
  EP_HEADING_25: 'Financial assistance from Export Credit Agencies (ECAs)',
  EP_HEADING_26: 'Financial incentives',
  EP_HEADING_27:
    'Other financial benefits received or receivable from any government for any operation',
  EP_HEADING_28: 'Country',

  EP_QUESTION_1: '',
  EP_QUESTION_2: 'Operating costs',
  EP_QUESTION_3: 'Employee wages and benefits',
  EP_QUESTION_4: 'Payments to providers of capital',
  EP_QUESTION_5: 'Payments to government by country',
  EP_QUESTION_6: 'Community investments',
  EP_QUESTION_7: '',
  EP_QUESTION_8: '',
  EP_QUESTION_9: '',
  EP_QUESTION_10: '',

  EP_QUESTION_11: '',
  EP_QUESTION_12: '',
  EP_QUESTION_13: '',
  EP_QUESTION_14: '',
  EP_QUESTION_15: '',
  EP_QUESTION_16: '',
  EP_QUESTION_17: '',
  EP_QUESTION_18: '',
  EP_QUESTION_19: 'Salary contributed for retirement plan',
  EP_QUESTION_20: 'Total salary',

  EP_QUESTION_21: '',
  EP_QUESTION_22: '',
  EP_QUESTION_23: '',
  EP_QUESTION_24: '',
  EP_QUESTION_25: '',
  EP_QUESTION_26: '',
  EP_QUESTION_27: '',
  EP_QUESTION_28: '',
  EP_QUESTION_29: '',
  EP_QUESTION_30: '',

  EP_QUESTION_31: '',
  EP_QUESTION_32: '',
  EP_QUESTION_33: '',
  EP_QUESTION_34: '',
  EP_QUESTION_35: '',
  EP_QUESTION_36: '',
  EP_QUESTION_37: '',
  EP_QUESTION_38: '',
  EP_QUESTION_39: '',
  EP_QUESTION_40: ''
};

// indirectEconomicImpacts----------------------------------
export const IndirectEconomicImpactsKey = {
  IEI_QUESTION_1: 'ieiQuestion1',
  IEI_QUESTION_2: 'ieiQuestion2',
  IEI_QUESTION_3: 'ieiQuestion3',
  IEI_QUESTION_4: 'ieiQuestion4',
  IEI_QUESTION_5: 'ieiQuestion5',
  IEI_QUESTION_6: 'ieiQuestion6',
  IEI_QUESTION_7: 'ieiQuestion7',
  IEI_QUESTION_8: 'ieiQuestion8',
  IEI_QUESTION_9: 'ieiQuestion9',
  IEI_QUESTION_10: 'ieiQuestion10'
};

export const IndirectEconomicImpactsLabel = {
  IEI_INDIRECT_ECONOMIC_IMPACTS_1:
    'Infrastructure investments and services supported',
  IEI_INDIRECT_ECONOMIC_IMPACTS_2: 'Significant indirect economic impacts',
  IEI_QUESTION_1: '',
  IEI_QUESTION_2: '',
  IEI_QUESTION_3: '',
  IEI_QUESTION_4: '',
  IEI_QUESTION_5: '',
  IEI_QUESTION_6: '',
  IEI_QUESTION_7: '',
  IEI_QUESTION_8: '',
  IEI_QUESTION_9: '',
  IEI_QUESTION_10: ''
};

// procurementPractices----------------------------------
export const ProcurementPracticesKey = {
  PP_QUESTION_1: 'ppQuestion1',
  PP_QUESTION_2: 'ppQuestion2',
  PP_QUESTION_3: 'ppQuestion3',
  PP_QUESTION_4: 'ppQuestion4'
};

export const ProcurementPracticesLabel = {
  PP_PROCUREMENT_PRACTICES_1: 'Proportion of spending on local suppliers',
  PP_QUESTION_1: 'Spending on Local Suppliers',
  PP_QUESTION_2: 'Total Spending',
  PP_QUESTION_3: '',
  PP_QUESTION_4: ''
};

// antiCorruption----------------------------------
export const AntiCorruptionKey = {
  AC_QUESTION_1: 'acQuestion1',
  AC_QUESTION_2: 'acQuestion2',
  AC_QUESTION_3: 'acQuestion3',
  AC_QUESTION_4: 'acQuestion4',
  AC_QUESTION_5: 'acQuestion5',
  AC_QUESTION_6: 'acQuestion6',
  AC_QUESTION_7: 'acQuestion7',
  AC_QUESTION_8: 'acQuestion8',
  AC_QUESTION_9: 'acQuestion9',
  AC_QUESTION_10: 'acQuestion10',

  AC_QUESTION_11: 'acQuestion11',
  AC_QUESTION_12: 'acQuestion12',
  AC_QUESTION_13: 'acQuestion13',
  AC_QUESTION_14: 'acQuestion14',
  AC_QUESTION_15: 'acQuestion15',
  AC_QUESTION_16: 'acQuestion16',
  AC_QUESTION_17: 'acQuestion17',
  AC_QUESTION_18: 'acQuestion18',
  AC_QUESTION_19: 'acQuestion19',
  AC_QUESTION_20: 'acQuestion20',

  AC_QUESTION_21: 'acQuestion21',
  AC_QUESTION_22: 'acQuestion22',
  AC_QUESTION_23: 'acQuestion23',
  AC_QUESTION_24: 'acQuestion24',
  AC_QUESTION_25: 'acQuestion25',
  AC_QUESTION_26: 'acQuestion26',
  AC_QUESTION_27: 'acQuestion27',
  AC_QUESTION_28: 'acQuestion28',
  AC_QUESTION_29: 'acQuestion29',
  AC_QUESTION_30: 'acQuestion30'
};

export const AntiCorruptionLabel = {
  AC_ANTI_CORRUPTION_1: 'Operations assessed for risks related to corruption',
  AC_ANTI_CORRUPTION_2:
    'Communication and training about anti-corruption policies and procedures',
  AC_ANTI_CORRUPTION_3: 'Confirmed incidents of corruption and actions taken',
  AC_QUESTION_1: '',
  AC_QUESTION_2:
    'Total number of operations assessed for risks related to corruption',
  AC_QUESTION_3: 'Total number of operations',
  AC_QUESTION_4: '',
  AC_QUESTION_5: '',
  AC_QUESTION_6:
    'Total number of governance body members that the organization’s anti-corruption policies and procedures have been communicated',
  AC_QUESTION_7: 'Total number of governance body members ',
  AC_QUESTION_8: '',
  AC_QUESTION_9:
    'Total number of employees that the organization’s anti-corruption policies and procedures have been communicated',
  AC_QUESTION_10: 'Total number of employees ',

  AC_QUESTION_11: '',
  AC_QUESTION_12:
    'Total number of business partners that the organization’s anti-corruption policies and procedures have been communicated',
  AC_QUESTION_13: 'Total number of business partners',
  AC_QUESTION_14: '',
  AC_QUESTION_15:
    'Total number of governance body members that have received training on anti-corruption',
  AC_QUESTION_16: 'Total number of governance body members',
  AC_QUESTION_17: '',
  AC_QUESTION_18:
    'Total number of employees that have received training on anti-corruption',
  AC_QUESTION_19: 'Total number of employees',
  AC_QUESTION_20: '',

  AC_QUESTION_21: '',
  AC_QUESTION_22: '',
  AC_QUESTION_23: '',
  AC_QUESTION_24: '',
  AC_QUESTION_25: '',
  AC_QUESTION_26: '',
  AC_QUESTION_27: '',
  AC_QUESTION_28: '',
  AC_QUESTION_29: '',
  AC_QUESTION_30: ''
};

// antiCompetitiveBehavior----------------------------------
export const AntiCompetitiveBehaviorKey = {
  ACB_QUESTION_1: 'acbQuestion1',
  ACB_QUESTION_2: 'acbQuestion2',
  ACB_QUESTION_3: 'acbQuestion3',
  ACB_QUESTION_4: 'acbQuestion4'
};

export const AntiCompetitiveBehaviorLabel = {
  ACB_ANTI_COMPETITIVE_BEHAVIOUR_1:
    'Legal actions for anti-competitive behavior, anti-trust, and monopoly practices',
  ACB_QUESTION_1: '',
  ACB_QUESTION_2: '',
  ACB_QUESTION_3: '',
  ACB_QUESTION_4: ''
};

// tax----------------------------------
export const TaxKey = {
  T_QUESTION_1: 'tQuestion1',
  T_QUESTION_2: 'tQuestion2',
  T_QUESTION_2_1: 'tQuestion2_1',
  T_QUESTION_2_2: 'tQuestion2_2',
  T_QUESTION_3: 'tQuestion3',
  T_QUESTION_4: 'tQuestion4',
  T_QUESTION_5: 'tQuestion5',
  T_QUESTION_6: 'tQuestion6',
  T_QUESTION_7: 'tQuestion7',
  T_QUESTION_8: 'tQuestion8',
  T_QUESTION_9: 'tQuestion9',
  T_QUESTION_10: 'tQuestion10',

  T_QUESTION_11: 'tQuestion11',
  T_QUESTION_12: 'tQuestion12',
  T_QUESTION_13: 'tQuestion13',
  T_QUESTION_14: 'tQuestion14',
  T_QUESTION_15: 'tQuestion15',
  T_QUESTION_16: 'tQuestion16',
  T_QUESTION_17: 'tQuestion17',
  T_QUESTION_18: 'tQuestion18',
  T_QUESTION_19: 'tQuestion19',
  T_QUESTION_20: 'tQuestion20',

  T_QUESTION_21: 'tQuestion21',
  T_QUESTION_22: 'tQuestion22',
  T_QUESTION_23: 'tQuestion23',
  T_QUESTION_24: 'tQuestion24',
  T_QUESTION_25: 'tQuestion25',
  T_QUESTION_26: 'tQuestion26',
  T_QUESTION_27: 'tQuestion27',
  T_QUESTION_28: 'tQuestion28',
  T_QUESTION_29: 'tQuestion29',
  T_QUESTION_30: 'tQuestion30'
};

export const TaxLabel = {
  T_TAX_1: 'Approach to tax',
  T_TAX_2: 'Tax governance, control, and risk management',
  T_TAX_3: 'Stakeholder engagement and management of concerns related to tax',
  T_TAX_4: 'Country-by-country reporting',
  T_TAX_5: 'Stakeholder engagement and management of concerns related to tax-',

  T_HEADING_1:
    'i. Whether the organization has a tax strategy and, if so, a link to this strategy if publicly available',
  T_HEADING_2:
    'ii. The governance body or executive-level position within the organization that formally reviews and approves the tax strategy, and the frequency of this review.',
  T_HEADING_3: 'iii. The approach to regulatory compliance.',
  T_HEADING_4:
    'iv. How the approach to tax is linked to the business and sustainable development strategies of the organization.',
  T_HEADING_5:
    'i. The governance body or executive-level position within the organization accountable for compliance with the tax strategy.',
  T_HEADING_6:
    'ii. How the approach to tax is embedded within the organization.',
  T_HEADING_7:
    'iii. The approach to tax risks, including how risks are identified, managed, and monitored.',
  T_HEADING_8:
    'iv. How compliance with the tax governance and control framework is evaluated.',
  T_HEADING_9: 'i. The approach to engagement with tax authorities.',
  T_HEADING_10: 'ii. The approach to public policy advocacy on tax.',
  T_HEADING_11:
    'iii. The processes for collecting and considering the views and concerns of stakeholders, including external stakeholders.',
  T_HEADING_12: 'i. Names of the resident entities.',
  T_HEADING_13: 'ii. Primary activities of the organization.',
  T_HEADING_14:
    'iii. Number of employees, and the basis of calculation of this number.',
  T_HEADING_15: 'iv. Revenues from third-party sales.',
  T_HEADING_16:
    'v. Revenues from intra-group transactions with other tax jurisdictions.',
  T_HEADING_17: 'vi. Profit/loss before tax.',
  T_HEADING_18: 'vii. Tangible assets other than cash and cash equivalents.',
  T_HEADING_19: 'viii. Corporate income tax paid on a cash basis.',
  T_HEADING_20: 'ix. Corporate income tax accrued on profit/loss.',
  T_HEADING_21:
    'x. Reasons for the difference between corporate income tax accrued on profit/loss and the tax due if the statutory tax rate is applied to profit/loss before tax.',

  T_QUESTION_1: '',
  T_QUESTION_2: '',
  T_QUESTION_2_1: '',
  T_QUESTION_2_2: '',
  T_QUESTION_3: '',
  T_QUESTION_4: '',
  T_QUESTION_5: '',
  T_QUESTION_6: '',
  T_QUESTION_7: '',
  T_QUESTION_8: '',
  T_QUESTION_9: '',
  T_QUESTION_10: '',

  T_QUESTION_11: '',
  T_QUESTION_12: '',
  T_QUESTION_13: '',
  T_QUESTION_14: '',
  T_QUESTION_15: '',
  T_QUESTION_16: '',
  T_QUESTION_17: 'Country',
  T_QUESTION_18: 'No. of Employees',
  T_QUESTION_19: '',
  T_QUESTION_20: '',

  T_QUESTION_21: '',
  T_QUESTION_22: '',
  T_QUESTION_23: '',
  T_QUESTION_24: '',
  T_QUESTION_25: '',
  T_QUESTION_26: '',
  T_QUESTION_27: '',
  T_QUESTION_28: '',
  T_QUESTION_29: '',
  T_QUESTION_30: ''
};
